import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCookieByShopId } from "../utils/getCookie";
import * as Actions from "../store/actions";
import { useParams } from "react-router-dom";
const useAuth = () => {
    const { shop_id } = useParams();
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.Auth);
    let token = getCookieByShopId("ts_access_token", shop_id);
    let userInfo = getCookieByShopId("ts_customer_info", shop_id);

    useEffect(() => {
        if (token && token !== "null" && !auth.authenticated) {
            dispatch(
                Actions.authLogin({
                    access_token: token,
                    shop_id,
                    user: userInfo || {},
                })
            );
        }
    }, []);
    return auth.authenticated || token;
};

export default useAuth;
